// extracted by mini-css-extract-plugin
module.exports = {"container":"KeyBenefitsSection_container__3BhG7","listWrapper":"KeyBenefitsSection_listWrapper__1KwOY"};